import { atom } from 'jotai';
import { atomFamily } from 'jotai-family';

import type { VisiblePalette } from './types';

/**
 * Jotai global state storing the currently opened palette.
 */
export const openedPaletteAtom = atom<VisiblePalette | null>(null);

export const isPaletteOpenedSelector = atom((get) => get(openedPaletteAtom) !== null);

export const paletteOpenedByIdSelector = atomFamily((id: string) =>
    atom((get) => {
        const state = get(openedPaletteAtom);
        return Boolean(state && state.id === id);
    })
);
